export const fmtTimeStr = (m) => {
  return m.toString().padStart(2, "00");
};

// 时间戳转时分秒
export const fmtTime = (time) => {
  const h = parseInt((time / 3600) % 60);
  const m = parseInt((time / 60) % 60);
  const s = parseInt(time % 60);
  return (h ? fmtTimeStr(h) + ":" : "") + fmtTimeStr(m) + ":" + fmtTimeStr(s);
};

export function getPlainTxt(text) {
  // 1. 删除所有形如 [00:15.33] 的时间戳
  let result = text
    .replace(/\[[^\]]+\]/g, "")
    // 2. 删除所有括号内的拼音部分（中英文括号都支持）
    .replace(/[(（][^)）]+[)）]/g, "")
    .replace(/^↵/, "") //去掉过滤后的字符第一个换行符
    // 3. 删除所有形如 "$标识符=数字" 的特殊标记
    // .replace(/\$[a-zA-Z]+\=\d+/g, '')
    // // 4. 删除所有类似 "@textAlign=left" 的标记
    // .replace(/@[a-zA-Z]+\=[a-zA-Z]+/g, '')
    // // 5. 删除所有形如 ";jxmb=1" 的标记
    // .replace(/;[a-zA-Z]+\=\d+/g, '')
    // // 6. 删除所有形如 "#zsd=1" 或 "#zsd=2" 的标记
    // .replace(/#[a-zA-Z]+\=\d+/g, '')
    .replace(/(?:[\$;#][a-zA-Z]+\=\d+)|(?:@[a-zA-Z]+\=[a-zA-Z\d]+)/g, '')
    // 7. 修改换行符
    .replace(/\$br=1|(\r\n|\n|\r)/g, "\n");
  return result;
}

// 倒计时
// let second = 60; //倒计时默认60秒
let timer = 0;
export const countDown = (second = 60, func) => {
  // let t = second;
  clearTime();
  const downFun = () => {
    second--;
    // console.log(second);
    if (second === 0) {
      // second = t;
      clearTime();
    } else {
      timer = setTimeout(downFun, 1000);
    }
    typeof func === "function" && func(second);
  };
  downFun();
};

export const clearTime = () => {
  clearTimeout(timer);
};